import { makeObservable, observable, action } from 'mobx'
import axios from "axios"

class Settings {

    item = {}
    loading = true

    constructor() {
        makeObservable( this, {
            init: action,
            item: observable,
            loading: observable,
        } )
    }

    async init() {

        this.loading = true

        await axios.get( `settings` )
            .then( ( response ) => {
                this.item = response.data
            } )
            .catch( ( error ) => {
                console.log( error );
            })
            .finally( () => {
                this.loading = false
            })

    }

}


export default new Settings()
